<div class="px-px-20">
  <app-calendar
    header="Planning des missions"
    [data]="randomData"
    [events]="events"
    [user]="user"
  ></app-calendar>

</div>
